export enum GradingMethod {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}
